import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';

export class ShipmentIntegrationActionConfig extends Model {
  @Expose() assign: boolean;
  @Expose() create: boolean;
  @Expose() cancel: boolean;
  @Expose() checkInGate: boolean;
  @Expose() requestPOD: boolean;
  @Expose() submitPOD: boolean;
  @Expose() track: boolean;
  @Expose() getDetails: boolean;
  @Expose() update: boolean;
  @Expose() getStatus: boolean;
}
